import { getDistrictList, getLocalityList } from "@store/slices/commonId";

export const fetchPermanentLocality = async ({cityId, prefix, setState, dispatch,setLoading}:any) => {

    // const dispatch: any = useDispatch()    
    if (!cityId) return;
    setLoading && setLoading(true);
    let districtOptions: any[] = [];

    const response: any = await dispatch(getLocalityList({ city: [cityId] }));
    if (response?.status === 200 && response?.data) {
        districtOptions = response.data.map((d: any) => ({
            label: d.label,
            value: d.value
        }));
        if (setState) {
            setState((prev: any) => {
                const updatedSectionItem = structuredClone(prev);

                for (let i = 0; i < updatedSectionItem.length; i++) {
                    const fields = updatedSectionItem[i].fields;

                    for (let j = 0; j < fields.length; j++) {
                        const subField = fields[j];

                        if (subField.name === `${prefix}_district`) {
                            subField.dynamicOptions = districtOptions;
                            subField.value = "";
                            subField.error_message = "";
                            subField.error_msg = "";
                        }
                    }
                }


                return updatedSectionItem;
            });
        }

    }
    setLoading && setLoading(false);
    return { districtOptions, response };
};



export const getPointValues = (leadDetail: any, callFrom: string) => {
  if (callFrom === "AgentComChangeList") {
    return {
      leadId:leadDetail?.application_id,  
      oldValue: leadDetail?.old_agent_value,
      oldPercentage: leadDetail?.old_agent_point,

      newValue: leadDetail?.agent_new_point_value,
      newPercentage: leadDetail?.agent_new_point,

      grossProfit: leadDetail?.oto_gross_profit,
    };
  }

  // Default: LeadList
  return {
    leadId:leadDetail?.leadId,
    oldValue: leadDetail?.agent_points?.value,
    oldPercentage: leadDetail?.agent_points?.percentage,
    newValue: leadDetail?.new_agent_points?.value,
    newPercentage: leadDetail?.new_agent_points?.percentage,

    grossProfit: leadDetail?.oto_gross_profit?.percentage,
  };
};
